import { render } from "./RoadbookSamplePair.vue?vue&type=template&id=35e62cb2"
import script from "./RoadbookSamplePair.vue?vue&type=script&lang=js"
export * from "./RoadbookSamplePair.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__